import type { ReactNode } from 'react';
import { useRestaurantStore } from '@/stores/restaurant.store';
import { useAccessState } from '../hooks/useAccessState';
import { SuspensionScreen } from './SuspensionScreen';

export function SuspensionGate({
  restaurantId,
  children,
}: {
  restaurantId: string;
  children: ReactNode;
}) {
  const { data, isPending, isFetching, refetch } = useAccessState(restaurantId);
  const restaurantName = useRestaurantStore((s) => s.restaurantConfig?.name ?? '');

  if (isPending) {
    return (
      <div className="suspension-pending">
        <div className="preloader" />
      </div>
    );
  }

  if (data?.suspended) {
    return (
      <SuspensionScreen
        state={data}
        restaurantName={restaurantName}
        checking={isFetching}
        onCheckAgain={() => void refetch()}
      />
    );
  }

  return <>{children}</>;
}
